import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from './api.service'

@Injectable()
export class ReceituariosService {
    constructor(
        private apiService: ApiService
    ) {}
        
    get(id): Observable<any> {
        let url : string = `/receituarios/${id}`
        return this.apiService.get(url)
    }
    
    getAll(dadosFiltro?): Observable<any> {
        let url : string = `/receituarios`
        return this.apiService.get(url, dadosFiltro)
    }
    
    restore(id) : Observable<any> {
        return this.apiService.get('/receituarios/reativar/'+id)
    }

    defineImpresso(id) : Observable<any> {
        return this.apiService.get('/receituarios/defineImpresso/'+id)
    }
    
    post(form) : Observable<any> {
        return this.apiService.post('/receituarios', form)
    }
    
    put(id: string, form) : Observable<any> {
        form._method='PUT'
        return this.apiService.post('/receituarios/'+id, form)
    }
    
    delete(id) {
        return this.apiService.delete('/receituarios/'+id)
    }
}